import { c as createSvgIcon } from '../../createSvgIcon-de76dc64.js';
import React from 'react';
import 'tslib';
import '@mui/material/SvgIcon';

var index = createSvgIcon(React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M 4.8,3.9 H 19.200041 C 20.199043,3.9 21,4.7009975 21,5.7 V 8.4000068 C 21,9.3990092 20.199043,10.20002 19.200041,10.20002 h -1.79996 v 2.700007 c 0,1.989 -1.611094,3.599959 -3.600054,3.599959 H 8.4000135 C 6.4109995,16.499986 4.8,14.889027 4.8,12.900027 Z m 10.799986,9.000027 V 5.7 H 6.6 v 7.200027 c 0,0.989998 0.810002,1.8 1.8000135,1.8 h 5.4000135 c 0.989957,0 1.799959,-0.810002 1.799959,-1.8 z M 17.400081,8.4000068 V 5.7 h 1.79996 V 8.4000068 Z M 3,18.300081 h 16.200041 v 1.79996 H 3 Z" }), 'Break');

export { index as default };
